import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-50 via-white to-brand-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <div className="w-full max-w-md px-4">
        <div className="mb-8 text-center">
          <img src="/logo.svg" alt="WooConnect" className="mx-auto h-16 w-16" />
          <h1 className="mt-4 text-3xl font-bold text-brand-600 dark:text-brand-400">WooConnect</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Powered by Wideview Entertainment</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
